import { ErrorOutlineOutlined as ErrorOutlineIcon } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { GroupTitleTemplate } from "@ryde/controls";

import { IGenericUploadFailedItem } from "./generic-upload.models";
import { GenericUploadProcessErrorListWrapperStyled } from "./generic-upload.styled";

interface IGenericUploadProcessErrorListProps {
  failedItems: IGenericUploadFailedItem[];
}

export const GenericUploadProcessErrorList: FC<
  IGenericUploadProcessErrorListProps
> = ({ failedItems }) => {
  const { t } = useTranslation();

  return (
    <GenericUploadProcessErrorListWrapperStyled>
      <GroupTitleTemplate
        name="errors"
        formLabel={t("genericUpload.failedRequests")}
      />
      <ul className="errors-wrapper">
        {failedItems.map((item, index) => (
          <li key={index} className="error-item">
            <ErrorOutlineIcon
              fontSize="small"
              color="error"
              className="error-icon"
            />
            <div className="error-text">
              <div>
                <strong>{t(`genericUpload.request${item.operation}`)}:</strong>{" "}
                {item.error}
              </div>
              {/* <div className="error-entity-data">
                {t("genericUpload.entityData")}
              </div> */}
              {/* <div className="error-entity-data">
                {JSON.stringify(item.dto, null, 2)}
              </div> */}
            </div>
          </li>
        ))}
      </ul>
    </GenericUploadProcessErrorListWrapperStyled>
  );
};
